<template>
  <div
    class="company__item"
    :class="{
      'company__item--selected': isSelectedCompany(company.id),
    }"
    @click="setSelectedCompany(company)"
  >
    <div
      class="item__logo"
      :class="isSelectedCompany(company.id) ? 'item__logo--selected' : 'item__logo--unselected'"
    >
      <img
        :src="company.foto_perfil_totem"
        :alt="company.nome"
        class="company__item--logo"
        @error="handleImgError"
      />
    </div>
  </div>
</template>
<script>
import config from '../config';
import defaultImage from "../../public/img/icons/hermes-icon-line.png";

export default {
  data() {
    return {
      imgPath: config.URL_IMAGE,
      fallbackImage: defaultImage,
    };
  },
  props: ["company", "selectedCompany"],
  emits: ["setSelectedCompany", 'onClick'],
  methods: {
    setSelectedCompany(company) {
      this.$emit("setSelectedCompany", company);
    },
    isSelectedCompany(id) {
      return this.selectedCompany.id === id;
    },
    onClick() {
      this.$emit("onClick", this.selectedCompany);
    },
     handleImgError(event) {
      event.target.src = this.fallbackImage;
    },
  },
  computed: {
      displayCompanyName() {
        return this.selectedCompany ? this.selectedCompany.nome.trim() : "";
      },
    },
};
</script>

<style scoped>
.company__item {
  width: 30%;
  height: 100%;
  /* min-width: 300px; */
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  border-radius: 4px;
  /* background-color: #827278c9; */
}



.company__item--logo {
  width: 80px;
  /* height: 80px; */
}

.company__text {
  /* font-size: 14px; */
  font-weight: 500;
  font-size: 0.9vw;
}

.item__logo {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.item__logo:hover{
  background: linear-gradient(
    180deg,
    rgba(153, 12, 9, 0.73) 0%,
    rgba(213, 19, 15, 0.73) 100%
  );;
}

.item__logo--selected {
    border-radius: 4px;
  background: linear-gradient(
    180deg,
    rgba(153, 12, 9, 0.73) 0%,
    rgba(213, 19, 15, 0.73) 100%
  );
}

.item__logo--selected:hover {
  /* background-color: #D5130F; */
  cursor: pointer;
  transition: all 0.3s ease;
}

.item__logo--unselected {
  background-color: #EDF0F8;
    border-radius: 4px;

}

.item__logo--unselected:hover {
  cursor: pointer;
  transition: all 0.3s ease;
}

.item__action--selected {
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  /* background-color: #ec7854; */
  padding: 30px;
  background: linear-gradient(
    180deg,
    rgba(213, 19, 15, 0.73) 0%,
    rgba(244, 113, 27, 0.73) 100%
  );

  p {
    margin-top: 20px;
  }
}
.item__action--unselected {
  width: 100%;
  height: 12%;
  display: flex;
  justify-content: end;
  align-items: center;
  background-color: #dce2f0bb;
}

.redirect-btn {
  background-color: transparent;
  border: none;
  font-family: "Poppins", sans-serif;
  text-decoration: underline;
}
</style>
